export const GOOGLE_MAP_FALLBACK_LAT_LNG = {
  lat: 35.717,
  lng: 139.731,
};
